export const SET_VERSION           = 'SET_VERSION';
